import z from 'zod';
import Registries from '../../docs/registries';

export const rawConfigSchema = z
  .object({
    $schema: z.string().optional(),
    tailwind: z.discriminatedUnion('version', [
      z.object({
        version: z.literal('v3'),
        css: z.string(),
        config: z.string(),
      }),
      z.object({
        version: z.literal('v4'),
        css: z.string(),
      }),
    ]),
    directory: z.object({
      components: z.string(),
      utilities: z.string(),
    }),
  })
  .strict();
export type RawConfig = z.infer<typeof rawConfigSchema>;

// -----------------------------------------------------------------------------
export const resolvedConfigSchema = rawConfigSchema.extend({
  resolvedPaths: z.object({
    tailwindConfig: z.string(),
    tailwindCss: z.string(),
    utilities: z.string(),
    components: z.string(),
  }),
});
export type ResolvedConfig = z.infer<typeof resolvedConfigSchema>;

// -----------------------------------------------------------------------------

const componentLiteralNames = Registries.map((r) => z.literal(r.name));
export type ComponentLiteralName =
  typeof componentLiteralNames extends Array<z.ZodLiteral<infer R>> ? R : never;

export const addOptionsSchema = z.object({
  cwd: z.string(),
  out: z.string().optional(),
  components: z.array(
    z.union(componentLiteralNames as any)
  ) as unknown as z.ZodArray<z.ZodLiteral<ComponentLiteralName>, 'many'>,
});

// -----------------------------------------------------------------------------
export const componentNotFoundErrorSchema = z.object({
  issues: z.array(
    z.object({
      code: z.string(),
      unionErrors: z.array(
        z.object({
          issues: z.array(
            z.object({
              received: z.string(),
              code: z.string(),
              expected: z.string(),
              path: z.array(z.number()),
              message: z.string(),
            })
          ),
          name: z.string(),
        })
      ),
      path: z.array(z.number()),
      message: z.string(),
    })
  ),
  name: z.string(),
});
